export class FiltreChampsFusion {

  static AutreFiltre = 'Autres';
  static config = [
    {
      libelle: 'Facture',
      filtre: ['Facture', 'Article'],
    },
    {
      libelle: 'Financement',
      filtre: ['Financement', 'DonneurOrdre', 'DossierFinancement'],
    },
    {
      libelle: 'Formations',
      filtre: ['Formation'],
    },
    {
      libelle: 'Inscriptions',
      filtre: ['Inscription'],
    },
    {
      libelle: 'Session',
      filtre: ['Session'],
    },
    {
      libelle: 'Séances',
      filtre: ['Seance'],
    },
    {
      libelle: 'Autres',
      filtre: ['Inscription', 'Formation', 'Session', 'Seance', 'Facture', 'Article', 'Financement', 'DonneurOrdre', 'DossierFinancement'],
    },
  ];

  static getLibelle(): Array<string> {
    return this.config.map(f => f.libelle);
  }

  static getMotCles(value: string) {
    if (value == null) {
      return null;
    }

    const config = this.config.find(f => f.libelle == value);
    return config.filtre;
  }
}

export enum FiltreOperations {
  startstWith,
  notStartsWith
}
